import { render } from "./TestReport.vue?vue&type=template&id=415f7004&scoped=true&ts=true"
import script from "./TestReport.vue?vue&type=script&lang=ts"
export * from "./TestReport.vue?vue&type=script&lang=ts"

import "./TestReport.vue?vue&type=style&index=0&id=415f7004&scoped=true&lang=css"
import "./TestReport.vue?vue&type=style&index=1&id=415f7004&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-415f7004"]])

export default __exports__